import { useQuery } from '@tanstack/react-query'
import { getMyLeaves } from '@/api/services/leaves.service'
import type { MyLeaveListQuery } from '@/features/leave/types/leave.types'

const myLeavesKeys = {
  list: (params?: MyLeaveListQuery) => ['leaves-me', params] as const,
}

export function useMyLeaves(params?: MyLeaveListQuery) {
  return useQuery({
    queryKey: myLeavesKeys.list(params),
    queryFn: () => getMyLeaves(params),
    staleTime: 2 * 60 * 1000,
    gcTime: 5 * 60 * 1000,
  })
}
